import React from "react";

import AgroTradeHeader from "../components/Header";
import ServicesSection from "../components/ServicesSection";
import LandingFooter from "../../landing/components/Footer";

function ServicesPage() {
    return (
        <div className="def_background min-h-screen flex flex-col">
            <AgroTradeHeader />
            <main className="flex-1">
                <div className="max-w-[1200px] mx-auto w-full px-4 py-10 lg:px-0">
                    <ServicesSection />
                </div>
            </main>
            <LandingFooter />
        </div>
    );
}

export default ServicesPage;

